import { AppRouting } from 'src/pages/app';
import { matchPath } from 'react-router-dom';

const matchRouting = () => {
  for (const route of AppRouting) {
    const match = matchPath(route.path, location.pathname);
    if (match) {
      return route;
    }
  }
  return null;
}

export const findBannerType = () => {
  const route = matchRouting();
  return route?.props?.bannerData;
};

export const useNavigationPath = () => {
  const route = matchRouting();

  return {
    forwardPath: route?.props?.forwardPath,
    backwardPath: route?.props?.backwardPath,
    flow: route?.props?.flow
  }
}